// extracted by mini-css-extract-plugin
export default {"warning":"WarningLabel_warning__34UbN","warning__text":"WarningLabel_warning__text__YPld0","tooltip":"WarningLabel_tooltip__0PC+4","label":"WarningLabel_label__26ppS"};